import { computed, unref, type MaybeRef } from 'vue'
import { createQuery } from '@/queries'
import { getConsentsCurrent, type ConsentsCurrent } from '@/features/account'

/**
 * Decision 18 — `GET /consents/current`. The key carries who asks (guest / signed in): a guest
 * gets every kind in `mustAccept`, a signed-in shopper only what she has not accepted.
 */
export const useConsentsCurrentQuery = (signedIn: MaybeRef<boolean>, enabled: MaybeRef<boolean> = true) => {
  return createQuery<ConsentsCurrent>({
    key: computed(() => (unref(enabled) ? ['consents', 'current', unref(signedIn) ? 'user' : 'guest'] : null)),
    fetcher: () => getConsentsCurrent(),
    staleTime: 10 * 60 * 1000,
  })
}
